var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"catalogue"},_vm._l((6),function(i){return _c('div',{key:i,staticClass:"drag-box",style:(_vm.colour(i)),attrs:{"draggable":"true"},on:{"dragstart":_vm.dragStart}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }